import styles from 'components/TopBanner/TopBanner.module.css';

export default function TopBanner() {
  return (
    <div className={styles["top-banner"]}>
        <h1>Supper Club Social</h1>
        <p>Connecting communities one homecooked meal at at time</p>
    </div>
  )
}
